define.alias("shared/components/shared/social/facebook-modal", "calendar/components/shared/social/facebook-modal");